/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "icon-filters-ad3d04e7--sprite",
  "use": "icon-filters-ad3d04e7--sprite-usage",
  "viewBox": "0 0 19 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 20\" id=\"icon-filters-ad3d04e7--sprite\"><path d=\"M10.078 9.775V1.506A.504.504 0 0 0 9.571 1a.504.504 0 0 0-.506.506v8.27A2.574 2.574 0 0 0 7 12.293c0 1.245.89 2.283 2.065 2.519v3.681c0 .281.225.506.506.506a.504.504 0 0 0 .507-.506v-3.681a2.574 2.574 0 0 0 2.065-2.519c0-1.24-.886-2.283-2.065-2.519zm-.507 4.075c-.86 0-1.557-.698-1.557-1.556a1.558 1.558 0 0 1 3.115 0c0 .858-.698 1.556-1.558 1.556zM4.078 5.532V1.506A.504.504 0 0 0 3.571 1a.504.504 0 0 0-.506.506v4.026A2.574 2.574 0 0 0 1 8.05c0 1.244.89 2.283 2.065 2.519v7.924c0 .281.225.506.506.506a.504.504 0 0 0 .507-.506v-7.928a2.574 2.574 0 0 0 2.065-2.519 2.57 2.57 0 0 0-2.065-2.515zm-.507 4.074c-.86 0-1.557-.697-1.557-1.555a1.558 1.558 0 0 1 3.115 0 1.56 1.56 0 0 1-1.558 1.555zM16.078 5.53V1.507A.504.504 0 0 0 15.571 1a.504.504 0 0 0-.506.506V5.53A2.574 2.574 0 0 0 13 8.049c0 1.245.89 2.283 2.065 2.519v7.926c0 .281.225.506.506.506a.504.504 0 0 0 .507-.506v-7.93a2.574 2.574 0 0 0 2.065-2.518 2.566 2.566 0 0 0-2.065-2.515zm-.507 4.075c-.86 0-1.557-.697-1.557-1.556a1.558 1.558 0 0 1 3.115 0c0 .859-.698 1.556-1.558 1.556z\" fill=\"#4264fd\" stroke=\"#4264fd\" stroke-width=\".5\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
